import React, { useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import componentMap from '../componentMap';
import { DataContext } from '../context/DataContext';
import Footer from '../components/Footer.js';  // added Footer import

const ContentPage = ({ data: propData }) => {
  const { models } = useContext(DataContext);
  const location = useLocation();
  const [data, setData] = React.useState(propData || null);

  useEffect(() => {
    // Use data passed from parent (LoadContent component)
    if (propData) {
      setData(propData);
    }
  }, [propData]);

  useEffect(() => {
    const scrollToHash = () => {
      const hash = location.hash;
      if (hash) {
        const element = document.getElementById(hash.replace('#', ''));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };
    scrollToHash();
  }, [location]);

  if (!data) {
    return <div>Page not found</div>;
  }

  return (
    <Box
      sx={{
        backgroundColor: (theme) => theme.palette.background.default,
        minHeight: '100vh',
      }}
    >
      {/* Header (full width) */}
      <Header
        title="BYD Electric Cars"
        models={models}
        menu={['Home', 'Vehicles', 'Contact']}
      />

      {/* Hero and About sections */}
      {data.hero && <Hero {...data.hero} />}
      {data.about && <About {...data.about} />}
      {(!data.hero && !data.about) && <Box sx={{ height: 70 }} />}

      {/* Fixed-width container for the rest of the content */}
      <Box
        sx={{
          width: '100%',
          maxWidth: 1200, // fixed maximum width
          minWidth: 320,  // minimum width for responsiveness
          mx: 'auto',     // center horizontally
          p: 2,           // padding around the container
        }}
      >
        {data.content &&
          data.content.map((block, index) => {
            const Component = componentMap[block.type];
            return Component ? <Component key={index} {...block} /> : null;
          })}
      </Box>

      {/* Footer (full width) */}
      <Footer />
    </Box>
  );
};

export default ContentPage;